<template>
  <div>
    <a-modal v-model="viewModal" :closable="false" :maskClosable="false">
      <a-result>
        <template #extra>
          <h3 :style="{ margin: '10px 0' }">Create Alumni Data</h3>
          <a-input class="mb-10" v-model="studentIdCreate" placeholder="Please input student ID" />
          <a-list size="small" bordered :data-source="data">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <span>
                <a-icon :type="item.icon" class="mr-10" theme="outlined" />
                {{ item.text }}
              </span>
            </a-list-item>
          </a-list>
        </template>
      </a-result>

      <template slot="footer">
        <a-row>
          <a-col :span="12" class="text-left">
            <a-button type="danger" @click="onCloseModal"> close </a-button>
          </a-col>
          <a-col :span="12">
            <a-button type="primary" size="lg" @click="onCreateForm">
              Create
            </a-button>
          </a-col>
        </a-row>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    viewModal: {
      type: Boolean,
      default: false,
    },
    onCloseModal: { type: Function },
  },
  data() {
    return {
      data: [
        { icon: "user", text: "Main" },
        { icon: "contacts", text: "Background" },
        { icon: "mail", text: "Contact" },
        { icon: "read", text: "Futher Education" },
        { icon: "read", text: "Work Experience" },
        // { icon: "trophy", text: "Achievements" },
      ],
      studentIdCreate: "",
    };
  },
  mounted() { },
  methods: {
    // onCloseModal() {
    //   this.studentIdCreate = "";
    //   this.$emit("hideModalCreate");
    // },
    async onCreateForm() {
      if (this.studentIdCreate != '') {
        try {
          var jsonData = {
            student_id: this.studentIdCreate 
          }
          const response = await this.$http.post(
            "/student_affair/alumni-profile/",
            jsonData
          );
          if (response.status === 201) {
            // //console.log(response.data.id);
            this.$router
              .push({
                path: "/alumni/formprofile",
                query: {
                  id: `${response.data.id}`,
                },
              })
              .catch((err) => { });
          } else {
            throw { response };
          }
        } catch (error) {
          this.loadBtnSubmit = false;
          this.errorSubmit = error;
          this.$notification['error']({
            message: function (h) {
              return h("div", [
                h("strong", { class: "" }, `Failed to connect to the API`),
              ]);
            },
            description:
              `Error ${error.response.status} : /student_affair/alumni-profile/`,
          });
        }
      } else {
        this.$message.error('Please fill out student id');
      }
    },
  },
};
</script>